import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card } from 'reactstrap';
import Modal from 'react-modal';
import { Icon } from 'react-fa';

import { Platform } from './Platform';
import './PlatformList.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/smartadmin-production.min.css';
import '../assets/css/smartadmin-production-plugins.min.css';

class PlatformList extends Component {
	state = { profileModal: false }

  toggleModal() {
    this.setState({ profileModal: !this.state.profileModal });
    this.props.onModalToggle();
  }

  render() {
  	return (
      <Card className="platforms-card">
        <h1><strong>Investment Platforms</strong></h1>
    		<Row>
    			<Col xs="12" sm="6" md="4" lg="3">
            <Platform          
              logo={require('../../assets/images/companies/betterment.png')}
              companySubtitle="Robot investing for beginers"
              rating={4}
              summary={`They are the perfect starting point for beginner investors. Betterment simplifies investing by focusing on the end-goal and with low-cost asset allocation. Though for some advanced investors, you might be able to do a better job yourself and avoid Betterment's annual fees.`}
              isLiquid
              minInvestment={0}
              tags={bettermentTags}
              isRobot
            />
    			</Col>
          <Col xs="12" sm="6" md="4" lg="3">
            <Platform 
              logo={require('../../assets/images/companies/fundrise-logo.svg')} 
              companySubtitle="Commercial Real Estate"
              rating={3.5}
              summary={`Invest online in commercial real estate via eREITS™. Gain access to real estate deals without the high dollar commitment typically needed, without being an accredited investor, and without paying the high front-end load fees typically charged by REITs. Though publicly traded REITs might be a better option.`}
              isLiquid={false}
              minInvestment={5000}
              tags={fundriseTags}
            />
          </Col>
          <Col xs="12" sm="6" md="4" lg="3">
            <Platform          
              logo={require('../../assets/images/companies/wealthfront-logo.png')}
              companySubtitle="Low fee robot advisor"
              rating={4}
              summary={`They are the perfect starting point for beginner investors. Betterment simplifies investing by focusing on the end-goal and with low-cost asset allocation. Though for some advanced investors, you might be able to do a better job yourself and avoid Betterment's annual fees.`}
              isLiquid
              minInvestment={500}
              tags={bettermentTags}
              isRobot
            />
          </Col>
          <Col xs="12" sm="6" md="4" lg="3">
            <Platform          
              logo={require('../../assets/images/companies/bloom-logo.png')}
              companySubtitle="401k robot advisor"
              rating={4}
              summary={`They are the perfect starting point for beginner investors. Betterment simplifies investing by focusing on the end-goal and with low-cost asset allocation. Though for some advanced investors, you might be able to do a better job yourself and avoid Betterment's annual fees.`}
              isLiquid
              minInvestment={10}
              tags={bettermentTags}
              isRobot
            />
          </Col>
    		</Row>
      </Card>
    );
  }

}

const bettermentTags = [
  {
    iconName:'robot',
    title: 'Robot Advisor'
  }
];


const fundriseTags = [
  {
    iconName:'home',
    title: 'Real Estate'
  }
];


export { PlatformList };



/** WEBPACK FOOTER **
 ** ./src/common/PlatformList.js
 **/